<template>
  <div
    class="container-fluid infinite-list"
    infinite-scroll-immediate="false"
    infinite-scroll-disabled="disabled"
    v-infinite-scroll="getDemandList"
  >
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <!-- 需求單單號 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">職缺單號</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model="searchCondition.ManpowerDemandNo"
              />
            </div>
          </div>

          <!-- 需求單名稱 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">職缺名稱</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model="searchCondition.ManpowerDemandName"
              />
            </div>
          </div>

          <!-- 職務名稱 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">{{ i18n("Position.PositionName") }}</label>
              <el-select
                class="w-100"
                filterable
                clearable
                placeholder="請選擇"
                v-model="searchCondition.PositionCode"
              >
                <el-option
                  v-for="position in positionOptions"
                  :key="position.Code"
                  :label="position.Name"
                  :value="position.Code"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 申請部門 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">{{ i18n("Basic.ApplyDepartment") }}</label>
              <treeselect
                :options="departmentOptions"
                :searchable="true"
                :show-count="true"
                :default-expand-level="1"
                placeholder="請選擇"
                v-model="searchCondition.demandDepartmentGuid"
              >
                <label
                  slot="option-label"
                  slot-scope="{
                    node,
                    shouldShowCount,
                    count,
                    labelClassName,
                    countClassName,
                  }"
                  :class="labelClassName"
                  for=""
                >
                  {{ node.label }}
                  <span v-if="shouldShowCount" :class="countClassName">
                    ({{ count }})
                  </span>
                </label>
              </treeselect>
            </div>
          </div>

          <!-- 申請人 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">申請人</label>
              <el-select
                class="w-100"
                filterable
                clearable
                placeholder="請選擇"
                v-model="searchCondition.ApplicantGuid"
              >
                <el-option
                  v-for="employee in employeeOptions"
                  :key="employee.Guid"
                  :label="employee.Name"
                  :value="employee.Guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 需求單狀態 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">職缺狀態</label>
              <el-select
                class="w-100"
                clearable
                multiple
                value-key="Key"
                placeholder="請選擇"
                v-model="searchCondition.ManpowerDemandStatus"
              >
                <el-option
                  v-for="status in statusOptions"
                  :key="status.Key"
                  :label="status.Value"
                  :value="status"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 按鈕 -->
          <div class="col-sm-12 col-md-6">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px"
              @click="(clickSearchBtn = true), getDemandList()"
            >
              {{ i18n("Buttons.Search") }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-left: 10px"
              @click="searchCondition = {}"
            >
              清除
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-left: 10px"
              @click="openSortDialog()"
            >
              前台職缺排序
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="demandList.length > 0">
      <div class="tool-list-item pop-messages pop">
        <p>
          <strong class="mr-3">總共：{{ totalDemand }} 筆</strong>
          <strong v-if="PendingQuantity !== 0" class="ml-2 mr-3">
            待決：{{ PendingQuantity }} 筆
          </strong>
          <strong v-if="ApprovedQuantity !== 0" class="ml-2 mr-3">
            同意：{{ ApprovedQuantity }} 筆
          </strong>
          <strong v-if="RejectedQuantity !== 0" class="ml-2 mr-3">
            否決：{{ RejectedQuantity }} 筆
          </strong>
          <strong v-if="SuspendQuantity !== 0" class="ml-2 mr-3">
            停用：{{ SuspendQuantity }} 筆
          </strong>
          <strong v-if="CancelledQuantity !== 0" class="ml-2">
            作廢：{{ CancelledQuantity }} 筆
          </strong>
        </p>
      </div>
      <div class="tool-list-about-card">
        <span
          @click="gridStyle = 'block'"
          :class="{ active: gridStyle == 'block' }"
        >
          <eva-icon fill="#000" name="grid-outline" />
        </span>
        <span
          @click="gridStyle = 'list'"
          :class="{ active: gridStyle == 'list' }"
        >
          <eva-icon fill="#000" name="list-outline" />
        </span>
      </div>
    </div>

    <!-- 需求單卡片 -->
    <div
      class="demand-card-list"
      :class="{
        'list-style': gridStyle === 'list',
        'block-style': gridStyle === 'block',
      }"
    >
      <div
        v-for="demand in demandList"
        :key="demand.Guid"
        class="demand-card infinite-list-item"
      >
        <DemandCard
          ref="demandCard"
          :category="'search'"
          :showCheckbox="false"
          :data="demand"
        >
          <template v-slot:search="{ props }">
            <template
              v-if="
                props.ManpowerDemandStatus === 'Approved' ||
                props.ManpowerDemandStatus === 'Suspend'
              "
            >
              <button
                type="button"
                class="btn"
                @click="getDemandDetail(props.Guid)"
              >
                編輯
              </button>
            </template>
            <template v-if="props.ManpowerDemandStatus === 'Approved'">
              <button
                type="button"
                class="btn"
                @click="suspendDemand(props.Guid)"
              >
                停用
              </button>
            </template>
            <template v-if="props.ManpowerDemandStatus === 'Suspend'">
              <button
                type="button"
                class="btn"
                @click="rebootDemand(props.Guid)"
              >
                啟用
              </button>
            </template>
          </template>
        </DemandCard>
      </div>
    </div>

    <!-- 編輯 Modal -->
    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <ValidationObserver v-slot="{ handleSubmit }">
            <div class="modal-header">
              <p>編輯職缺</p>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  職缺名稱
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="edit.ManpowerDemandName"
                />
              </div>
              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  需求人數
                </label>
                <input
                  type="number"
                  class="form-control"
                  min="1"
                  v-model.number="edit.DemandNumber"
                />
              </div>

              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  招募期限
                </label>
                <date-picker
                  class="w-100"
                  format="YYYY-MM-DD"
                  valueType="format"
                  v-model="edit.RecruitmentDeadline"
                >
                </date-picker>
              </div>
              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  工作地點
                </label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <multiselect
                    :options="workplaceOptions"
                    :close-on-select="false"
                    :multiple="true"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    track-by="WorkPlaceGuid"
                    label="WorkPlace"
                    placeholder="請選擇"
                    v-model="edit.ManpowerDemandWorkPlace"
                  />
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <div class="form-check form-check-inline">
                  <label for="" class="form-check-label">
                    <span style="color: #ff0000">*</span>
                    學歷
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <label class="form-check-label">
                    <input
                      type="checkbox"
                      v-model="edit.EducationDemandWhatever"
                    />不拘
                  </label>
                </div>
                <template v-if="!edit.EducationDemandWhatever">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <multiselect
                      :options="educationDegreeOptions"
                      :close-on-select="false"
                      :multiple="true"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      track-by="EducationDegreeGuid"
                      label="EducationDegree"
                      placeholder="請選擇"
                      v-model="edit.ManpowerDemandEducationDegree"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </div>
              <div class="form-group">
                <div class="form-check form-check-inline">
                  <label for="" class="form-check-label">
                    <span style="color: #ff0000">*</span>
                    工作經驗
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <label class="form-check-label">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      v-model="edit.WorkExperienceWhatever"
                    />不拘
                  </label>
                </div>
                <template v-if="!edit.WorkExperienceWhatever">
                  <ValidationProvider
                    name="工作經驗"
                    rules="min_value:1|required"
                    v-slot="{ errors }"
                  >
                    <input
                      class="form-control w-70"
                      type="number"
                      min="1"
                      v-model.number="edit.WorkExperience"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </div>
              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  工作內容
                </label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <textarea
                    rows="10"
                    class="form-control"
                    v-model="edit.WorkContent"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  {{ i18n("DemandApply.ManagementResponsibility") }}
                </label>

                <input
                  type="checkbox"
                  v-model="edit.ManagementResponsibility"
                />
                {{ i18n("DemandApply.Require") }}
                (若勾選，請填寫管理人數)
              </div>

              <div class="form-group" v-if="edit.ManagementResponsibility">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  管理人數
                </label>
                <ValidationProvider
                  class="w-100"
                  rules="min_value:1|required"
                  name="管理人數"
                  v-slot="{ errors }"
                >
                  <input
                    type="number"
                    min="1"
                    class="form-control w-100"
                    v-model="edit.ManagementNumber"
                  />
                  <div>
                    <span class="text-danger" v-if="errors[0]">
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  {{ i18n("DemandApply.BusinessTrip") }}
                </label>
                <ValidationProvider
                  class="w-100"
                  rules="required"
                  name="出差"
                  v-slot="{ errors }"
                >
                  <label class="form-check-label">
                    <input type="checkbox" v-model="edit.BusinessTrip" />
                    {{ i18n("DemandApply.Require") }}
                  </label>
                  <div>
                    <span class="text-danger" v-if="errors[0]">
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  {{ i18n("DemandApply.Expat") }}
                </label>
                <ValidationProvider
                  class="w-100"
                  rules="required"
                  name="外派"
                  v-slot="{ errors }"
                >
                  <label class="form-check-label">
                    <input type="checkbox" v-model="edit.OverseasWork" />
                    {{ i18n("DemandApply.Require") }}
                  </label>
                  <div>
                    <span class="text-danger" v-if="errors[0]">
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  {{ i18n("DemandApply.Shifts") }}
                </label>
                <ValidationProvider
                  class="w-100"
                  rules="required"
                  name="輪班"
                  v-slot="{ errors }"
                >
                  <label class="form-check-label">
                    <input type="checkbox" v-model="edit.Shift" />
                    {{ i18n("DemandApply.Require") }}
                  </label>
                  <div>
                    <span class="text-danger" v-if="errors[0]">
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  {{ i18n("DemandApply.ShiftType") }}
                </label>

                <div
                  v-for="item in newWorkingHours"
                  :key="item.WorkShiftTypeGuid"
                  class="form-check"
                >
                  <label class="form-check-label">
                    <input
                      type="checkbox"
                      :value="item"
                      v-model="edit.ManpowerDemandWorkShiftType"
                    />
                    {{ item.WorkShiftType }}
                  </label>
                  <input
                    type="text"
                    class="form-control w-100"
                    placeholder="請填寫詳細時段或排班資訊"
                    v-model.trim="item.WorkShiftTypeDescription"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  薪資類型
                </label>

                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-select
                    class="w-100"
                    :options="salaryTypeList"
                    label="Name"
                    placeholder="請選擇"
                    v-model="salaryTypeValue"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  v-if="salaryTypeValue && salaryTypeValue.Code === 'other'"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    class="form-control"
                    style="margin-top: 5px"
                    placeholder="請填寫薪資類型"
                    v-model="edit.SalaryTypeDescription"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  職務聯絡人
                </label>

                <ValidationProvider rules="required" v-slot="{ errors }">
                  <multiselect
                    class="w-100"
                    :options="supervisorOptions"
                    placeholder="請選擇"
                    label="Name"
                    track-by="Email"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    :taggable="true"
                    @tag="addPositionContactorTag"
                    v-model="edit.PositionContactor"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  職務聯絡人Email
                </label>
                <ValidationProvider rules="required|email" v-slot="{ errors }">
                  <input
                    type="email"
                    class="form-control"
                    v-model="edit.PositionContactorEmail"
                  />

                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for="">
                  {{ i18n("DemandApply.Major") }}
                </label>

                <div
                  v-for="(
                    majorItem, index
                  ) in edit.ManpowerDemandSchoolDepartment"
                  :key="index"
                  style="margin-bottom: 20px"
                >
                  <span class="language-title">
                    {{ majorItem.SchoolDepartmentType }}
                  </span>
                  <h6 style="margin-bottom: 12px">
                    <span class="language-text">
                      {{
                        majorItem.SchoolDepartment
                          ? majorItem.SchoolDepartment
                          : null
                      }}
                      <span v-if="majorItem.SchoolDepartmentDescription">
                        ｜科系描述：{{ majorItem.SchoolDepartmentDescription }}
                      </span>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        @click="deleteItem(index, 'Education')"
                      >
                        <eva-icon fill="#FFF" name="trash-2-outline" />
                      </button>
                    </span>
                  </h6>
                </div>
                <div>
                  <AddMajor
                    v-if="addMajor"
                    @addMajor="saveItem"
                    @addCancel="cancelItem('Education')"
                  />
                  <button
                    v-else
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="addItem('Education')"
                  >
                    <i class="fas fa-plus"></i>
                    {{ i18n("DemandApply.Major") }}
                  </button>
                </div>
              </div>

              <div class="form-group">
                <label for=""> 證照 </label>

                <el-cascader
                  class="w-100"
                  :options="certifications"
                  clearable
                  filterable
                  :props="props"
                  :show-all-levels="false"
                  :filter-method="certificationsFilter"
                  @change="certificationsChange"
                  v-model="chooseCertifications"
                />
                <ValidationProvider
                  v-if="certificateOther"
                  tag="section"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <textarea
                    v-model="certificateDescription"
                    class="form-control mt-2"
                    rows="5"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label for=""> 其他條件 </label>
                <textarea
                  class="form-control"
                  rows="3"
                  maxlength="500"
                  v-model="edit.OtherConditions"
                />
              </div>

              <div class="form-group">
                <label for=""> 薪資待遇 </label>
                <div class="form-row">
                  <div class="col-md">
                    <ValidationProvider
                      tag="section"
                      name="薪資待遇(低)"
                      :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                      v-slot="{ errors }"
                    >
                      <input
                        type="text"
                        class="form-control text-right"
                        v-model.trim="edit.SalaryLow"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  ~
                  <div class="col-md">
                    <ValidationProvider
                      tag="section"
                      name="薪資待遇(高)"
                      :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                      v-slot="{ errors }"
                    >
                      <input
                        type="text"
                        class="form-control text-right"
                        v-model.trim="edit.SalaryHigh"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  預設身份別
                </label>
                <ValidationProvider
                  class="w-100"
                  name="預設身份別"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="edit.AppointmentDefaultIdentityType"
                    :disabled="!$Permission.Appointment.DLPermission.IsValid"
                  >
                    <el-option label="IDL" value="IDL" />
                    <el-option label="IDL工讀生" value="IDL工讀生" />
                    <el-option label="DL" value="DL" />
                    <el-option label="按摩師" value="按摩師" />
                    <el-option
                      label="DL產學合作4+2產學生(高中畢業)"
                      value="DL產學合作4+2產學生(高中畢業)"
                    />
                    <el-option
                      label="DL產學合作1年期實習生(大四學生)"
                      value="DL產學合作1年期實習生(大四學生)"
                    />
                    <el-option label="外籍" value="外籍" />
                  </el-select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <template v-if="edit.ResumeType === 'DL'">
                <div class="form-group">
                  <label for=""> 預設職稱 </label>
                  <el-select
                    class="w-100"
                    placeholder="請選擇"
                    v-model="edit.AppointmentDefaultPosition"
                    :disabled="!$Permission.Appointment.DLPermission.IsValid"
                  >
                    <el-option label="生產助理員" value="生產助理員" />
                    <el-option label="助理" value="助理" />
                    <el-option label="技術助理員" value="技術助理員" />
                    <el-option label="技術員" value="技術員" />
                    <el-option label="高級技術員" value="高級技術員" />
                    <el-option label="事務員" value="事務員" />
                    <el-option label="資深技術員" value="資深技術員" />
                    <el-option label="組長" value="組長" />
                    <el-option label="儲備組長" value="儲備組長" />
                    <el-option label="工讀生" value="工讀生" />
                    <el-option label="實習生" value="實習生" />
                    <el-option label="按摩師" value="按摩師" />
                  </el-select>
                </div>

                <div class="form-group">
                  <label for=""> 預設職等 </label>
                  <el-select
                    class="w-100"
                    placeholder="請選擇"
                    v-model="edit.AppointmentDefaultRank"
                    :disabled="!$Permission.Appointment.DLPermission.IsValid"
                  >
                    <el-option label="1" value="1" />
                    <el-option label="2" value="2" />
                    <el-option label="2.1" value="2.1" />
                    <el-option label="2.2" value="2.2" />
                    <el-option label="3" value="3" />
                    <el-option label="4" value="4" />
                    <el-option label="5" value="5" />
                    <el-option label="6" value="6" />
                    <el-option label="6.3" value="6.3" />
                    <el-option label="7" value="7" />
                    <el-option label="7.3" value="7.3" />
                    <el-option label="8" value="8" />
                    <el-option label="8.3" value="8.3" />
                    <el-option label="9" value="9" />
                    <el-option label="9.3" value="9.3" />
                    <el-option label="10" value="10" />
                    <el-option label="10.3" value="10.3" />
                    <el-option label="10.5" value="10.5" />
                    <el-option label="10.7" value="10.7" />
                    <el-option label="11" value="11" />
                    <el-option label="11.3" value="11.3" />
                    <el-option label="11.5" value="11.5" />
                    <el-option label="12" value="12" />
                    <el-option label="13" value="13" />
                    <el-option label="13.3" value="13.3" />
                  </el-select>
                </div>

                <div class="form-group">
                  <label for=""> 預設薪資 </label>
                  <ValidationProvider
                    name="預設薪資"
                    :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control text-right"
                      v-model.trim="edit.AppointmentDefaultSalary"
                      :disabled="!$Permission.Appointment.DLPermission.IsValid"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </template>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                取消
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="handleSubmit(editDemand)"
              >
                儲存
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 檢視需求單 -->
    <DemandDetailModal />

    <!-- API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    />

    <!-- 前台職缺排序 modal -->
    <div id="sortModal" class="modal fade" tabindex="-1" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <span>前台職缺排序</span>
          </div>

          <div class="modal-body">
            <draggable :list="openingOptions" class="d-list">
              <div
                v-for="(element, index) in openingOptions"
                :key="index"
                class="d-item"
                :title="element.ManpowerDemandName"
              >
                {{ index + 1 }} {{ element.ManpowerDemandName }}
              </div>
            </draggable>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button type="button" class="btn btn-primary" @click="saveSort()">
              確定
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import DemandCard from "@/components/back/Card/Demand";
import DemandDetailModal from "@/components/back/Modal/DemandDetail";
import ResponseDataModal from "@/components/back/Modal/ResponseData";
import AddMajor from "@/components/back/DemandForm/AddMajor.vue";

export default {
  name: "DemandSearch",

  components: {
    DemandCard,
    DemandDetailModal,
    ResponseDataModal,
    AddMajor,
  },
  data() {
    return {
      // 需求單列表顯示樣式(區塊/條列)
      gridStyle: "block",

      clickSearchBtn: false,

      // 需求單狀態
      statusOptions: [
        { Key: "Approved", Value: "同意" },
        { Key: "Suspend", Value: "停用" },
        { Key: "Cancelled", Value: "作廢" },
      ],

      // 學歷選項
      educationDegreeOptions: [],
      // 工作地點選項
      workplaceOptions: [],

      // 查詢
      positionOptions: [], // 職務列表
      departmentOptions: [], // 部門列表
      employeeOptions: [], // 人員列表
      searchCondition: {},

      // 需求單列表
      demandList: [],

      // API 回應資訊
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息

      // 編輯需求單
      edit: {},

      // 需求單各狀態數量
      PendingQuantity: 0,
      ApprovedQuantity: 0,
      RejectedQuantity: 0,
      CancelledQuantity: 0,
      SuspendQuantity: 0,

      // 班別
      workingHours: [],
      newWorkingHours: [], // copy workingHours

      // 薪資類型
      salaryTypeList: [],
      salaryTypeValue: null,

      // 簽核主管
      supervisorOptions: [], // 列表

      // 元件
      addMajor: false, // 新增科系

      // 證照
      certifications: [],
      certificateOther: false,
      certificateDescription: null,
      chooseCertifications: [],

      // el-cascader
      props: { multiple: true },

      // 分頁
      totalDemand: 0, // 總數
      currentPage: 1, // 當前頁數
      // 停止call API（停止取得下一頁）
      stopGetNextPage: false,

      // 用來排序的職缺選項
      openingOptions: [],
    };
  },

  methods: {
    // 取得需求單列表
    getDemandList() {
      if (this.clickSearchBtn) {
        this.demandList = [];
        this.totalDemand = 0;
        this.currentPage = 1;
        this.stopGetNextPage = false;
      } else if (this.totalDemand > 0) {
        if (this.totalDemand > 36) {
          if (this.totalDemand === this.demandList.length) {
            this.stopGetNextPage = true;
            return;
          } else {
            this.currentPage++;
            this.stopGetNextPage = false;
          }
        } else {
          this.stopGetNextPage = true;
          return;
        }
      }

      this.updateLoading(true);
      this.$api.manpowerDemand
        .getManpowerDemandStatus({
          ...this.searchCondition,
          ManpowerDemandStatus:
            Object.keys(this.searchCondition.ManpowerDemandStatus).length > 0
              ? this.searchCondition.ManpowerDemandStatus.map((item) => {
                  return item.Key;
                }).toString()
              : "Approved,Suspend,Cancelled",
          ManpowerDemandSupervisorGuid: null,
          IsPaging: true,
          Page: this.currentPage,
          PerPage: 36,
          Ordering: "RecruitmentDeadline",
          OrderingAsc: false,
        })
        .then((response) => {
          if (response.status === 200) {
            this.clickSearchBtn = false;
            this.totalDemand =
              response.data.DataQuantity - response.data.NewQuantity;

            this.PendingQuantity = response.data.PendingQuantity;
            this.ApprovedQuantity = response.data.ApprovedQuantity;
            this.RejectedQuantity = response.data.RejectedQuantity;
            this.CancelledQuantity = response.data.CancelledQuantity;
            this.SuspendQuantity = response.data.SuspendQuantity;

            let newArr = response.data.Datas.filter((element) => {
              if (element.ManpowerDemandStatus !== "New") {
                let demandItem = {
                  ...element,
                  checked: false,
                };
                return demandItem;
              }
            });

            let oldArr;
            if (this.currentPage === 1) {
              oldArr = [];
            } else {
              oldArr = this.demandList;
            }
            this.demandList = oldArr.concat(newArr);
          }
          this.updateLoading(false);
        });
    },

    // 取得 需求單詳細資訊
    getDemandDetail(demandGuid) {
      this.updateLoading(true);
      this.$api.manpowerDemand
        .getManpowerDemandDetail(demandGuid)
        .then((response) => {
          if (response.status === 200) {
            this.edit = {
              ...response.data,
              ManpowerDemandWorkPlace:
                response.data.ManpowerDemandWorkPlace.map((item) => {
                  return {
                    WorkPlaceGuid: item.WorkPlaceGuid,
                    WorkPlace: item.WorkPlace,
                  };
                }),
              RecruitmentDeadline: this.$common.dateFormatter(
                response.data.RecruitmentDeadline
              ),
              ManpowerDemandEducationDegree:
                response.data.ManpowerDemandEducationDegree.map((item) => {
                  return {
                    EducationDegreeGuid: item.EducationDegreeGuid,
                    EducationDegree: item.EducationDegree,
                  };
                }),
            };

            const vm = this;

            // 班別
            vm.newWorkingHours = vm.workingHours.map((item) => {
              return { ...item };
            });
            vm.newWorkingHours.forEach((o1, index, arr) =>
              vm.edit.ManpowerDemandWorkShiftType.map((o2) => {
                if (o1.WorkShiftTypeGuid === o2.WorkShiftTypeGuid) {
                  arr[index].WorkShiftTypeDescription =
                    o2.WorkShiftTypeDescription;
                }
              })
            );
            vm.edit.ManpowerDemandWorkShiftType = vm.newWorkingHours.filter(
              (o1) =>
                vm.edit.ManpowerDemandWorkShiftType.some(
                  (o2) => o1.WorkShiftTypeGuid === o2.WorkShiftTypeGuid
                )
            );

            // 薪資類型
            vm.salaryTypeValue = {
              Code: vm.edit.SalaryTypeDescription ? "other" : null,
              PositionName: vm.edit.PositionName,
              Guid: vm.edit.SalaryTypeGuid,
              Name: vm.edit.SalaryType,
            };
            vm.salaryTypeDescription = vm.edit.SalaryTypeDescription;

            // 職務聯絡人
            const PositionContactorData = {
              Name: this.edit.PositionContactor,
              Email: this.edit.PositionContactorEmail,
            };
            this.edit.PositionContactor = this.supervisorOptions.filter(
              (o1) => PositionContactorData.Email === o1.Email
            );

            if (this.edit.PositionContactor.length > 0) {
              this.edit.PositionContactor = this.edit.PositionContactor[0];
            } else {
              this.supervisorOptions.push(PositionContactorData);
              this.edit.PositionContactor = PositionContactorData;
            }

            // 證照來源(扁平化)
            const flatten = (data) => {
              return data.reduce((r, { children, ...rest }) => {
                r.push(rest);
                if (children) r.push(...flatten(children));
                return r;
              }, []);
            };
            let flatCertifications = flatten(vm.certifications);
            let filterCertifications = flatCertifications.filter((o1) =>
              vm.edit.ManpowerDemandCertificate.some(
                (o2) => o1.value.split("+")[0] === o2.CertificateGuid
              )
            );
            vm.edit.ManpowerDemandCertificate.forEach((o1, index, arr) =>
              filterCertifications.map((o2) => {
                if (o1.CertificateGuid === o2.value.split("+")[0]) {
                  arr[index].CertificateCode = o2.value.split("+")[2];
                }
              })
            );

            // 證照 el-cascader
            vm.chooseCertifications = vm.edit.ManpowerDemandCertificate.map(
              (category) => {
                return [
                  `${category.CertificateCategoryTop}`,
                  `${category.CertificateCategorySecond}`,
                  `${category.CertificateGuid}+${category.Certificate}+${category.CertificateCode}`,
                ];
              }
            );

            // 證照 array
            vm.edit.ManpowerDemandCertificate =
              vm.edit.ManpowerDemandCertificate.map((item) => {
                if (item.CertificateDescription) {
                  vm.certificateOther = true;
                  vm.certificateDescription = item.CertificateDescription;
                }
                return {
                  CertificateCategoryTop: item.CertificateCategoryTop,
                  CertificateCategorySecond: item.CertificateCategorySecond,
                  CertificateGuid: item.CertificateGuid,
                  Certificate: item.Certificate,
                  CertificateCode: item.CertificateCode,
                  CertificateDescription: item.CertificateDescription,
                };
              });

            vm.addMajor = false;

            $("#editModal").modal("show");
          }
          this.updateLoading(false);
        });
    },

    // 編輯 需求單
    editDemand() {
      $("#editModal").modal("hide");
      this.updateLoading(true);

      let data = {
        UpdateUser: this.$cookies.get("userName"),
        ...this.edit,
      };

      data.ManpowerDemandEducationDegree = data.EducationDemandWhatever
        ? null
        : data.ManpowerDemandEducationDegree;

      data.WorkExperience = data.WorkExperienceWhatever
        ? null
        : Number(data.WorkExperience);

      data.AppointmentDefaultSalary = data.AppointmentDefaultSalary
        ? Number(data.AppointmentDefaultSalary.replace(/,/g, ""))
        : null;

      data.SchoolDepartmentWhatever =
        data.ManpowerDemandSchoolDepartment.length === 0;

      data.PositionContactor = this.edit.PositionContactor.Name;

      // 管理人數
      data.ManagementNumber = data.ManagementResponsibility
        ? Number(data.ManagementNumber)
        : null;

      // 薪資類型
      data.SalaryTypeGuid = this.salaryTypeValue.Guid;
      data.SalaryType = this.salaryTypeValue.Name;

      // 薪資區間
      data.SalaryLow = data.SalaryLow
        ? Number(data.SalaryLow.replace(/,/g, ""))
        : null;
      data.SalaryHigh = data.SalaryHigh
        ? Number(data.SalaryHigh.replace(/,/g, ""))
        : null;

      // 證照
      data.ManpowerDemandCertificate = data.ManpowerDemandCertificate.map(
        (item) => {
          return {
            ...item,
            CertificateDescription:
              item.CertificateCode === "other"
                ? this.certificateDescription
                : null,
          };
        }
      );

      this.$api.manpowerDemand.putApproved(data).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "編輯成功",
            type: "success",
            duration: 2000,
          });
        }
        this.updateLoading(false);
      });
    },

    // 停用 需求單
    suspendDemand(demandGuid) {
      this.updateLoading(true);
      this.$api.manpowerDemand
        .suspendManpowerDemand(demandGuid)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "停用成功",
              type: "success",
              duration: 2500,
            });
            this.demandList = [];
            this.totalDemand = 0;
            this.currentPage = 1;
            this.stopGetNextPage = false;
            this.getDemandList();
          }
          this.updateLoading(false);
        });
    },

    // 啟用 需求單
    rebootDemand(demandGuid) {
      this.updateLoading(true);
      this.$api.manpowerDemand
        .rebootManpowerDemand(demandGuid)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "啟用成功",
              type: "success",
              duration: 2500,
            });
            this.demandList = [];
            this.totalDemand = 0;
            this.currentPage = 1;
            this.stopGetNextPage = false;
            this.getDemandList();
          }
          this.updateLoading(false);
        });
    },

    // 刪除 科系 & 語言 & 方言 元件
    deleteItem(itemIndex, category) {
      if (category === "Education") {
        this.edit.ManpowerDemandSchoolDepartment.forEach((item, index) => {
          if (itemIndex === index) {
            this.edit.ManpowerDemandSchoolDepartment.splice(index, 1);
          }
        });
      }
    },

    // 新增 科系 & 語言 & 方言 元件
    addItem(category) {
      switch (category) {
        case "Language":
          this.addLanguage = true;
          break;
        case "Dialect":
          this.addDialect = true;
          break;
        case "Education":
          this.addMajor = true;
          break;
      }
    },

    // 取消新增 科系 & 語言 & 方言 元件
    cancelItem(category) {
      switch (category) {
        case "Language":
          this.addLanguage = false;
          break;
        case "Dialect":
          this.addDialect = false;
          break;
        case "Education":
          this.addMajor = false;
          break;
      }
    },

    // 儲存 科系 & 語言 & 方言 元件
    saveItem(item, type) {
      let educationIndex;
      if (type === "Education") {
        this.addMajor = false;
        // 判斷科系是否重複
        educationIndex = this.edit.ManpowerDemandSchoolDepartment.findIndex(
          (element) =>
            element.SchoolDepartmentGuid === item.SchoolDepartmentGuid
        );
        if (item.SchoolDepartmentGuid !== null) {
          const departmentIndex =
            this.edit.ManpowerDemandSchoolDepartment.findIndex(
              (element) =>
                element.SchoolDepartmentType === item.SchoolDepartmentType &&
                element.SchoolDepartmentGuid === null
            );
          if (departmentIndex === -1) {
            educationIndex === -1
              ? this.edit.ManpowerDemandSchoolDepartment.push({
                  ...item,
                })
              : this.edit.ManpowerDemandSchoolDepartment.splice(
                  educationIndex,
                  1,
                  {
                    ...item,
                  }
                );
          }
        } else {
          this.edit.ManpowerDemandSchoolDepartment =
            this.edit.ManpowerDemandSchoolDepartment.filter(
              (dept) => dept.SchoolDepartmentType !== item.SchoolDepartmentType
            );
          this.edit.ManpowerDemandSchoolDepartment.push({ ...item });
        }
      }
    },

    // 取得證照
    getCertifications() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/CertificateCategory/WithDetail`;

      // 將單一證照映射成想要的格式
      function mapCertificate(certificate) {
        return {
          label: certificate.Name,
          value: `${certificate.Guid}+${certificate.Name}+${certificate.Code}`,
        };
      }

      // 將分類映射成格式，並包含子證照
      function mapCategory(category) {
        return {
          label: category.Name,
          value: category.Name,
          children: category.Certificates.map(mapCertificate),
        };
      }

      // 將證照類型映射成格式，並包含子分類
      function mapType(type) {
        return {
          label: type.Name,
          value: type.Name,
          children: type.Children.map(mapCategory),
        };
      }

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.certifications = response.data.map(mapType);
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "證照列表取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 選擇證照
    certificationsChange(value) {
      if (value.length === 0) {
        this.certificateOther = false;
        this.certificateDescription = null;
      } else {
        let findOther = value
          .map((item) => {
            return item[2].split("+")[2];
          })
          .indexOf("other");
        if (findOther === -1) {
          this.certificateOther = false;
          this.certificateDescription = null;
        } else {
          this.certificateOther = true;
        }
        this.edit.ManpowerDemandCertificate = value.map((item) => {
          return {
            CertificateCategoryTop: item[0],
            CertificateCategorySecond: item[1],
            CertificateGuid: item[2].split("+")[0],
            Certificate: item[2].split("+")[1],
            CertificateCode: item[2].split("+")[2],
            CertificateDescription:
              item[2].split("+")[2] === "other"
                ? this.certificateDescription
                : null,
          };
        });
      }
    },

    // 搜尋證照關鍵字(不區分大小寫)
    certificationsFilter(node, keyword) {
      if (
        !!~node.text.indexOf(keyword) ||
        !!~node.text.toUpperCase().indexOf(keyword.toUpperCase())
      ) {
        return true;
      }
    },

    // 職務聯絡人
    addPositionContactorTag(newTag) {
      const tag = {
        Name: newTag,
        Guid: `${newTag.substring(0, 3)}-${crypto.randomUUID()}`,
      };
      this.supervisorOptions.push(tag);
      this.edit.PositionContactor = tag;
    },

    async getData() {
      try {
        await this.$http
          .all([
            this.$api.department.getDepartment(),
            this.$api.workplace.getWorkplacePaging({ isPaging: false }),
            this.$api.position.getPositionPaging({ isPaging: false }),
            this.$api.education.getEducationDegree(),
            this.$api.backgroundUser.getBackgroundUser(),
          ])
          .then(
            this.$http.spread(
              (department, workplace, position, degree, backgroundUser) => {
                // 取得 部門選項
                this.departmentOptions = department.data;
                // 取得 工作地點選項
                this.workplaceOptions = workplace.data.Datas.map((item) => {
                  return {
                    WorkPlaceGuid: item.Guid,
                    WorkPlace: item.WorkPlaceName,
                  };
                });
                // 取得 職務選項
                this.positionOptions = position.data.Datas.map((item) => {
                  return {
                    Code: item.PositionCode,
                    Name: item.PositionName,
                  };
                });
                // 取得 學歷程度選項
                this.educationDegreeOptions = degree.data.map((item) => {
                  return {
                    EducationDegreeGuid: item.Guid,
                    EducationDegree: item.Name,
                  };
                });
                // 取得 申請者選項
                this.employeeOptions = backgroundUser.data.map((user) => {
                  return {
                    Guid: user.UserId,
                    Name: user.Name,
                  };
                });
                // 取得主管列表
                this.supervisorOptions = backgroundUser.data.map((user) => {
                  return {
                    Guid: user.UserId,
                    Name: user.Name,
                    Email: user.Email,
                  };
                });
              }
            )
          );
        await this.getDemandList();
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // 開啟修改排序modal
    async openSortDialog() {
      this.$store.dispatch("updateLoading", true);

      const opening = await this.$api.opening.getOpening();
      this.openingOptions = opening.data.map((item) => {
        return {
          ManpowerDemandNo: item.ManpowerDemandNo,
          ManpowerDemandName: item.ManpowerDemandName,
        };
      });

      this.$store.dispatch("updateLoading", false);
      $("#sortModal").modal("show");
    },

    async saveSort() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      await vm.$api.opening.sortOpening(vm.openingOptions).then((response) => {
        if (response.status === 200) {
          this.demandList = [];
          this.totalDemand = 0;
          this.currentPage = 1;
          this.getDemandList();
        }
      });

      vm.$store.dispatch("updateLoading", false);
      $("#sortModal").modal("hide");
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    disabled() {
      return this.stopGetNextPage;
    },

    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    // 預設薪資
    "edit.AppointmentDefaultSalary": function (newVal) {
      if (newVal) {
        this.edit.AppointmentDefaultSalary = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    // 證照
    "edit.ManpowerDemandCertificate": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        const foundOther = newVal.filter((item) => {
          return item.CertificateCode.indexOf("other") === 0;
        });
        if (foundOther.length === 0) {
          this.certificateDescription = null;
        }
      }
    },

    // 職務聯絡人
    "edit.PositionContactor": function (e) {
      this.edit.PositionContactorEmail = e ? e.Email : null;
    },

    // 薪資待遇(低)
    "edit.SalaryLow": function (newVal) {
      if (newVal) {
        this.edit.SalaryLow = this.$common.currencyThousands(String(newVal));
      }
    },
    // 薪資待遇(高)
    "edit.SalaryHigh": function (newVal) {
      if (newVal) {
        this.edit.SalaryHigh = this.$common.currencyThousands(String(newVal));
      }
    },
  },

  created() {
    this.getData();
    this.getCertifications();

    this.$http.all([this.get_working_hours(), this.get_salary_type()]).then(
      this.$http.spread((working_hours, salary_type) => {
        this.workingHours = working_hours;
        this.newWorkingHours = this.workingHours;

        this.salaryTypeList = salary_type;
      })
    );
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.d-list {
  min-height: 300px;
  background-color: #fafafa;
  padding: 5px;
  border-radius: 5px;
  height: 100%;
  display: flex;
  flex-direction: column;
  max-height: 420px;
  flex-wrap: wrap;
  overflow: auto;
  .d-item {
    border-radius: 5px;
    padding: 3px 10px;
    margin: 5px;
    background-color: #dcebff;
    cursor: move;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 200px;
    white-space: nowrap;
  }
}
</style>
